import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "schedule-section mt-2" }
const _hoisted_2 = { class: "schedule-card" }
const _hoisted_3 = { class: "detail-list" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-icon" }
const _hoisted_6 = { class: "detail-copy" }
const _hoisted_7 = { class: "detail-value" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "detail-icon" }
const _hoisted_10 = { class: "detail-copy" }
const _hoisted_11 = { class: "detail-value" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = { class: "detail-icon" }
const _hoisted_14 = { class: "detail-copy" }
const _hoisted_15 = { class: "detail-value" }
const _hoisted_16 = {
  key: 0,
  class: "note-card"
}
const _hoisted_17 = { class: "note-text" }

import { computed, type PropType } from "vue";
import { formatTime, formatWeekdayMonthDay, getStatusColor } from "@/shared/utils/utils";

type AppointmentSchedule = {
  appointment_no?: string | null;
  status?: string | null;
  schedule_info?: {
    appointment_date: string | null;
    appointment_time: string | null;
    note: string | null;
  } | null;
  service_address?: {
    add1: string | null;
    add2: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    country: string | null;
  } | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentScheduleDetailsCard',
  props: {
  appointment: {
    type: Object as PropType<AppointmentSchedule>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const appointmentNo = computed(() => props.appointment.appointment_no || "-");
const scheduleDateTime = computed(() => {
  const s = props.appointment.schedule_info;
  if (!s?.appointment_date) return "-";
  const label = formatWeekdayMonthDay(s.appointment_date);
  return s.appointment_time ? `${label}, ${formatTime(s.appointment_time)}` : label;
});

const fullAddress = computed(() => {
  const a = props.appointment.service_address;
  if (!a) return "-";
  const parts = [a.add1, a.add2, a.city, a.state, a.zip, a.country]
    .map((p) => (p ?? "").trim())
    .filter(Boolean);
  return parts.length ? parts.join(", ") : "-";
});

const note = computed(() => props.appointment.schedule_info?.note || "");

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("p", { class: "schedule-section-title" }, "Schedule Details")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-pound", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "detail-label" }, "Appointment No.", -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(appointmentNo.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-clock-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "detail-label" }, "Date & Time", -1)),
            _createElementVNode("p", _hoisted_11, _toDisplayString(scheduleDateTime.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-map-marker-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "detail-label" }, "Service Address", -1)),
            _createElementVNode("p", _hoisted_15, _toDisplayString(fullAddress.value), 1)
          ])
        ])
      ]),
      (note.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "note-label" }, "Notes", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(note.value), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})